var window=global;var $CLJS=require("./cljs_env");
$CLJS.aa=$CLJS.aa||{};$CLJS.ea=global;$CLJS.fa="closure_uid_"+(1E9*Math.random()>>>0);$CLJS.ha=Date.now||function(){return+new Date};$CLJS.ea=global;